import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=5d9c56a9&scoped=true&"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts&"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts&"
import style0 from "./PageNotFoundView.vue?vue&type=style&index=0&id=5d9c56a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c56a9",
  null
  
)

export default component.exports